import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useT } from '../context/LocaleContext';
import LanguageSwitch from '../components/LanguageSwitch';
import PoweredBy from '../components/PoweredBy';

export default function LoginPage() {
  const { session, isStaff, loading, signIn } = useAuth();
  const location = useLocation();
  const t = useT();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!loading && session && isStaff) {
    const to = location.state?.from || '/';
    return <Navigate to={to} replace />;
  }

  async function onSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    const { error: authError } = await signIn(email.trim(), password);
    if (authError) setError(authError.message);
    setSubmitting(false);
  }

  return (
    <div className="login-stage">
      <form className="login-card" onSubmit={onSubmit}>
        <div className="login-lang">
          <LanguageSwitch />
        </div>
        <span className="kicker">{t('login.kicker')}</span>
        <h1>{t('login.title')}</h1>
        <p className="lede">{t('login.lede')}</p>
        <label>
          {t('login.email')}
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label>
          {t('login.password')}
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        {error && <p className="form-error">{error}</p>}
        <button type="submit" className="primary" disabled={submitting}>
          {submitting ? t('login.submitting') : t('login.submit')}
        </button>
        <PoweredBy />
      </form>
    </div>
  );
}
